/**
 * @generated SignedSource<<e0a819dc35adb2821f0cb9b3bbebf5e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type clientQueryLoaderHomeV2Query$variables = {
  excludeSsrContentEntityIds: ReadonlyArray<string | null | undefined>;
  isAsiaEdition: boolean;
  isHongKongEdition: boolean;
  mostPopularQueueName: string;
  multimediaQueueName: string;
  trendingTopicsQueueName: string;
};
export type clientQueryLoaderHomeV2Query$data = {
  readonly advertisers: {
    readonly items: {
      readonly " $fragmentSpreads": FragmentRefs<"advertisersHomeV2QueueItemConnection">;
    } | null | undefined;
  } | null | undefined;
  readonly china: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly hongKong?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly lifestyle: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly peopleCulture?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly style: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly twia?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly wellness?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"mostPopularHomeV2Query" | "multimediaHomeV2Query" | "sectionTopHomeV2Query" | "trendingTopicHomeV2Topic">;
};
export type clientQueryLoaderHomeV2Query = {
  response: clientQueryLoaderHomeV2Query$data;
  variables: clientQueryLoaderHomeV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeSsrContentEntityIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAsiaEdition"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isHongKongEdition"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mostPopularQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "multimediaQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "trendingTopicsQueueName"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_4"
    }
  }
],
v2 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "entityIds",
      "variableName": "excludeSsrContentEntityIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "exclude"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 7
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge"
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_2"
    }
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_94"
    }
  }
],
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v10 = [
  (v2/*: any*/),
  (v9/*: any*/)
],
v11 = [
  {
    "alias": null,
    "args": (v10/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_318202"
    }
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_72"
    }
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_323045"
    }
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_24"
    }
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "homepage_brand_post_int"
    }
  }
],
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v20/*: any*/),
            "type": "Content",
            "abstractKey": "__isContent"
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v24 = [
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v23/*: any*/),
    "storageKey": null
  },
  (v21/*: any*/)
],
v25 = [
  {
    "alias": null,
    "args": (v10/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v23/*: any*/),
    "storageKey": null
  },
  (v21/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v30 = [
  (v29/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v34 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v37 = [
  (v27/*: any*/)
],
v38 = {
  "kind": "InlineFragment",
  "selections": (v37/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v37/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        (v38/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v42 = [
  (v19/*: any*/),
  (v21/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v48/*: any*/),
        (v49/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v51/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v41/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v47/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v50/*: any*/),
        (v52/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "types",
      "storageKey": null
    },
    (v21/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    (v50/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v57 = [
  (v9/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/),
    (v31/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v60 = [
  (v59/*: any*/)
],
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v60/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v60/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v60/*: any*/),
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v18/*: any*/),
            (v48/*: any*/),
            (v22/*: any*/),
            (v49/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v52/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v58/*: any*/),
    (v21/*: any*/),
    (v61/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v18/*: any*/),
        (v40/*: any*/),
        (v41/*: any*/),
        (v43/*: any*/),
        (v44/*: any*/),
        (v47/*: any*/),
        (v62/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v68 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v69 = [
  (v29/*: any*/),
  (v33/*: any*/),
  (v28/*: any*/),
  (v68/*: any*/),
  (v34/*: any*/)
],
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v69/*: any*/),
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSectionUnion"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v27/*: any*/),
            (v61/*: any*/)
          ],
          "type": "Section",
          "abstractKey": null
        },
        (v38/*: any*/),
        (v22/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v19/*: any*/),
            (v40/*: any*/),
            (v26/*: any*/),
            (v41/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v47/*: any*/),
            (v62/*: any*/)
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v73 = [
  (v72/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v59/*: any*/)
  ],
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/),
    (v40/*: any*/),
    (v26/*: any*/),
    (v41/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v47/*: any*/),
    (v62/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "multimediaEmbed",
      "plural": false,
      "selections": (v73/*: any*/),
      "storageKey": null
    },
    (v45/*: any*/),
    (v46/*: any*/),
    (v77/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v21/*: any*/),
        (v78/*: any*/)
      ],
      "storageKey": null
    },
    (v51/*: any*/),
    (v55/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v21/*: any*/),
            (v27/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVideoContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "leadingSlides",
      "plural": true,
      "selections": (v69/*: any*/),
      "storageKey": null
    },
    (v54/*: any*/),
    (v61/*: any*/),
    (v56/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v49/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "youtubeId",
      "storageKey": null
    },
    (v80/*: any*/),
    (v81/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "100x100"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": "style(filter:{\"style\":\"100x100\"})"
    }
  ],
  "storageKey": null
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v26/*: any*/),
    (v41/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v47/*: any*/),
    (v62/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v85 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*: any*/),
              (v27/*: any*/),
              (v84/*: any*/)
            ],
            "type": "Section",
            "abstractKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "Queue",
  "kind": "LinkedField",
  "name": "topStories",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": (v4/*: any*/),
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v19/*: any*/),
                    (v26/*: any*/),
                    (v36/*: any*/),
                    (v63/*: any*/),
                    (v64/*: any*/),
                    (v65/*: any*/),
                    (v66/*: any*/),
                    (v67/*: any*/),
                    (v32/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "images",
                      "plural": true,
                      "selections": [
                        (v29/*: any*/),
                        (v33/*: any*/),
                        (v28/*: any*/),
                        (v68/*: any*/),
                        (v34/*: any*/),
                        {
                          "alias": "landscape250x99",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "filter",
                              "value": {
                                "style": "landscape_250_99"
                              }
                            }
                          ],
                          "concreteType": "ImageStyle",
                          "kind": "LinkedField",
                          "name": "style",
                          "plural": false,
                          "selections": (v30/*: any*/),
                          "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                        }
                      ],
                      "storageKey": null
                    },
                    (v35/*: any*/),
                    (v71/*: any*/),
                    (v74/*: any*/),
                    (v75/*: any*/),
                    (v76/*: any*/),
                    (v53/*: any*/),
                    (v79/*: any*/),
                    (v82/*: any*/)
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v21/*: any*/)
  ],
  "storageKey": null
},
v87 = [
  (v27/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": (v57/*: any*/),
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v85/*: any*/),
        "storageKey": "items(first:5)"
      },
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  (v86/*: any*/),
  (v21/*: any*/),
  (v78/*: any*/)
],
v88 = [
  (v3/*: any*/)
],
v89 = [
  (v27/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 6
          }
        ],
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v85/*: any*/),
        "storageKey": "items(first:6)"
      },
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  (v86/*: any*/),
  (v21/*: any*/),
  (v78/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientQueryLoaderHomeV2Query",
    "selections": [
      {
        "alias": "china",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_4\"})"
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "hongKong",
            "args": (v7/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
          }
        ]
      },
      {
        "alias": "lifestyle",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_94\"})"
      },
      {
        "condition": "isHongKongEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "peopleCulture",
            "args": (v12/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_318202\"})"
          }
        ]
      },
      {
        "alias": "style",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_72\"})"
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "twia",
            "args": (v14/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
          }
        ]
      },
      {
        "condition": "isHongKongEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "wellness",
            "args": (v15/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_24\"})"
          }
        ]
      },
      {
        "alias": "advertisers",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "advertisersHomeV2QueueItemConnection"
              }
            ],
            "storageKey": "items(first:20)"
          }
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_brand_post_int\"})"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "mostPopularQueueName",
            "variableName": "mostPopularQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "mostPopularHomeV2Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "multimediaQueueName",
            "variableName": "multimediaQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "multimediaHomeV2Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "excludeSsrContentEntityIds",
            "variableName": "excludeSsrContentEntityIds"
          },
          {
            "kind": "Variable",
            "name": "isAsiaEdition",
            "variableName": "isAsiaEdition"
          },
          {
            "kind": "Variable",
            "name": "isHongKongEdition",
            "variableName": "isHongKongEdition"
          }
        ],
        "kind": "FragmentSpread",
        "name": "sectionTopHomeV2Query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "trendingTopicsQueueName",
            "variableName": "trendingTopicsQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "trendingTopicHomeV2Topic"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientQueryLoaderHomeV2Query",
    "selections": [
      {
        "alias": "china",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v24/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_4\"})"
      },
      {
        "alias": "lifestyle",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_94\"})"
      },
      {
        "alias": "style",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v25/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_72\"})"
      },
      {
        "alias": "advertisers",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsor",
                                "kind": "LinkedField",
                                "name": "sponsor",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v21/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v29/*: any*/),
                              (v33/*: any*/),
                              (v28/*: any*/),
                              (v34/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v39/*: any*/),
                          (v53/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v19/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:20)"
          },
          (v21/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"homepage_brand_post_int\"})"
      },
      {
        "alias": "mostPopularV2Queue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "mostPopularQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v57/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v26/*: any*/),
                          (v36/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v32/*: any*/),
                          (v70/*: any*/),
                          (v35/*: any*/),
                          (v71/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v53/*: any*/),
                          (v79/*: any*/),
                          (v82/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "multimediaV2",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "multimediaQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v57/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v26/*: any*/),
                          (v32/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/),
                              (v58/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v70/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v21/*: any*/),
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v83/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PodcastSection",
                                "kind": "LinkedField",
                                "name": "podcastSections",
                                "plural": true,
                                "selections": [
                                  (v83/*: any*/),
                                  (v27/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Podcast",
                            "abstractKey": null
                          },
                          (v53/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v80/*: any*/),
                              (v81/*: any*/)
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:5)"
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "chinaSectionV2",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "4"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": (v87/*: any*/),
        "storageKey": "section(filter:{\"entityId\":\"4\"})"
      },
      {
        "alias": "lifestyleSectionV2",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "94"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 4
                  }
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v85/*: any*/),
                "storageKey": "items(first:4)"
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v86/*: any*/),
          (v21/*: any*/),
          (v78/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"94\"})"
      },
      {
        "alias": "styleSectionV2",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "entityId": "72"
            }
          }
        ],
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v27/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "subSections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v88/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v85/*: any*/),
                "storageKey": "items(first:7)"
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v86/*: any*/),
          (v21/*: any*/),
          (v78/*: any*/)
        ],
        "storageKey": "section(filter:{\"entityId\":\"72\"})"
      },
      {
        "alias": "trendingTopicsV2Queue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "trendingTopicsQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v88/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v27/*: any*/),
                          (v19/*: any*/),
                          (v84/*: any*/)
                        ],
                        "type": "Topic",
                        "abstractKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:7)"
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "hongKong",
            "args": (v7/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
          },
          {
            "alias": "hongKongSectionV2",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "2"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v89/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"2\"})"
          }
        ]
      },
      {
        "condition": "isHongKongEdition",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "peopleCulture",
            "args": (v12/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_318202\"})"
          },
          {
            "alias": "peopleCultureSectionV2",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "318202"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v87/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"318202\"})"
          }
        ]
      },
      {
        "condition": "isAsiaEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "twia",
            "args": (v14/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
          },
          {
            "alias": "twiaSectionV2",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "323045"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v89/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"323045\"})"
          }
        ]
      },
      {
        "condition": "isHongKongEdition",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "wellness",
            "args": (v15/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_24\"})"
          },
          {
            "alias": "wellnessSectionV2",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "24"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v87/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"24\"})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fbf059f9db37245c9ecf1e5f43492321",
    "id": null,
    "metadata": {},
    "name": "clientQueryLoaderHomeV2Query",
    "operationKind": "query",
    "text": "query clientQueryLoaderHomeV2Query(\n  $excludeSsrContentEntityIds: [String]!\n  $isAsiaEdition: Boolean!\n  $isHongKongEdition: Boolean!\n  $mostPopularQueueName: String!\n  $multimediaQueueName: String!\n  $trendingTopicsQueueName: String!\n) {\n  china: queue(filter: {name: \"section_top_4\"}) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  hongKong: queue(filter: {name: \"section_top_2\"}) @skip(if: $isAsiaEdition) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  lifestyle: queue(filter: {name: \"section_top_94\"}) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  peopleCulture: queue(filter: {name: \"section_top_318202\"}) @skip(if: $isHongKongEdition) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  style: queue(filter: {name: \"section_top_72\"}) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  twia: queue(filter: {name: \"section_top_323045\"}) @include(if: $isAsiaEdition) {\n    items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  wellness: queue(filter: {name: \"section_top_24\"}) @include(if: $isHongKongEdition) {\n    items(first: 5, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  advertisers: queue(filter: {name: \"homepage_brand_post_int\"}) {\n    items(first: 20) {\n      ...advertisersHomeV2QueueItemConnection\n    }\n    id\n  }\n  ...mostPopularHomeV2Query_KkbCb\n  ...multimediaHomeV2Query_4rBIay\n  ...sectionTopHomeV2Query_1dUDys\n  ...trendingTopicHomeV2Topic_4tMn4o\n}\n\nfragment advertisersHomeV2QueueItemConnection on QueueItemConnection {\n  edges {\n    node {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n        ...homeAdvertiserV2ContentItemContent\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_1SslBT on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      url\n      title\n      type\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size540x360: style(filter: {style: \"540x360\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment contentCoverImageContent_2ihLSb on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3lvIh0 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_gEdhx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment contentVideoClickToPlayContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment headerSectionTopHomeV2QueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Section {\n      entityId\n      name\n      ...entityLink\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment headerSectionTopHomeV2Section on Section {\n  name\n  ...entityLink\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetLabelContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Gallery {\n    __typename\n  }\n  ... on Video {\n    __typename\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeAdvertiserV2ContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  flag\n  ...entityLink\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1jqb9M\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1jqb9M on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_1SslBT\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ...contentVideoClickToPlayContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_gEdhx\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3SIuYu on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2ihLSb\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment leadSectionTopHomeV2Content on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...homeSecondaryV2ContentItemContent\n  ...contentCoverImageContent_3lvIh0\n}\n\nfragment mostPopularHomeV2Query_KkbCb on Query {\n  mostPopularV2Queue: queue(filter: {name: $mostPopularQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment multimediaHomeV2Query_4rBIay on Query {\n  multimediaV2: queue(filter: {name: $multimediaQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ... on Article {\n              types {\n                value {\n                  name\n                  id\n                }\n              }\n            }\n            ...multimediaPodcastV2ContentItemContent\n            ...multimediaV2ContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment multimediaPodcastV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    images {\n      style(filter: {style: \"100x100\"}) {\n        url\n      }\n    }\n  }\n  ... on Podcast {\n    podcastSections {\n      images {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      name\n      id\n    }\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment multimediaV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersGetLabelContent\n  ...hooksContentItemProvidersContent_3SIuYu\n}\n\nfragment oneSectionTopWidgetHomeV2Queue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n      ...leadSectionTopHomeV2Content\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n}\n\nfragment sectionTopHomeV2Query_1dUDys on Query {\n  chinaSectionV2: section(filter: {entityId: \"4\"}) {\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  hongKongSectionV2: section(filter: {entityId: \"2\"}) @skip(if: $isAsiaEdition) {\n    name\n    subSections {\n      items(first: 6) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  lifestyleSectionV2: section(filter: {entityId: \"94\"}) {\n    name\n    subSections {\n      items(first: 4) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  peopleCultureSectionV2: section(filter: {entityId: \"318202\"}) @skip(if: $isHongKongEdition) {\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  wellnessSectionV2: section(filter: {entityId: \"24\"}) @include(if: $isHongKongEdition) {\n    name\n    subSections {\n      items(first: 5) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  styleSectionV2: section(filter: {entityId: \"72\"}) {\n    name\n    subSections {\n      items(first: 7) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n  twiaSectionV2: section(filter: {entityId: \"323045\"}) @include(if: $isAsiaEdition) {\n    name\n    subSections {\n      items(first: 6) {\n        edges {\n          ...headerSectionTopHomeV2QueueItemsEdge\n        }\n      }\n      id\n    }\n    topStories {\n      items(first: 7, exclude: {entityIds: $excludeSsrContentEntityIds}) {\n        edges {\n          node {\n            __typename\n            ... on Content {\n              __isContent: __typename\n              entityId\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          ...oneSectionTopWidgetHomeV2Queue\n          ...twoSectionTopWidgetHomeV2Queue\n        }\n      }\n      id\n    }\n    ...headerSectionTopHomeV2Section\n    id\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment trendingTopicHomeV2Topic_4tMn4o on Query {\n  trendingTopicsV2Queue: queue(filter: {name: $trendingTopicsQueueName}) {\n    items(first: 7) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            name\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment twoSectionTopWidgetHomeV2Queue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeSecondaryV2ContentItemContent\n      ...leadSectionTopHomeV2Content\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48e239125c8feba6ac73f58a599cbd9f";

export default node;
